import { useQuery } from '@tanstack/react-query'
import { AxiosError } from 'axios'
import { IMaterialCategory } from '../../../model/material.interface'
import { DEFAULT_LOCALE, LOCALE_KEY } from '../../i18n/config'
import useTranslation from '../../i18n/useTranslation'
import { landingCoursesQueryApi, landingTutorsQueryApi } from '../../react-query/queryApis'

//* ============================================================================================================== */

interface ILandingCourses {
  success: boolean
  categories: IMaterialCategory[]
}

export const useLandingCourses = () => {
  const { locale } = useTranslation()
  const searchParams = { locale: locale == LOCALE_KEY ? DEFAULT_LOCALE : locale }

  return useQuery<ILandingCourses, AxiosError>({
    queryKey: landingCoursesQueryApi.getQueryKey({ searchParams }),
    queryFn: landingCoursesQueryApi.getQueryFn({ searchParams }),

    // onError: (e) => handleAxiosError(e),
    staleTime: 1000 * 60 * 24,
    cacheTime: 1000 * 60 * 24,
  })
}
//* ============================================================================================================== */

interface ILandingTutors {
  landing_tutor_categories: any
  landing_tutors: { id: number; name: string; avatar: string; category_id: number; tutors: any[] }[]
  success: boolean
}

export const useLandingTutors = () => {
  const { locale } = useTranslation()
  const searchParams = { locale: locale == LOCALE_KEY ? DEFAULT_LOCALE : locale }

  return useQuery<ILandingTutors, AxiosError>({
    queryKey: landingTutorsQueryApi.getQueryKey({ searchParams }),
    queryFn: landingTutorsQueryApi.getQueryFn({ searchParams }),

    // onError: (e) => handleAxiosError(e),
  })
}
